export default __webpack_public_path__ + "static/media/brand2.ad14ad05.webp";